jQuery(($) => {

    if ($('.m-gallery-carousel__list')[0]) {
        $('.m-gallery-carousel__list').slick({
            speed: 900,
            centerMode: true,
            centerPadding: '20.875%',
            slidesToShow: 1,
            infinite: true,
            swipe: true,
            swipeToSlide: true,
            arrows: true,
            dots: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    centerPadding: '10%',
                },
            }, 
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '5%',
                    appendArrows: '.m-gallery-carousel .js-arrow-navigation',
                    appendDots: '.m-gallery-carousel .js-dot-navigation',
                }
            },
             {
                breakpoint: 500,
                settings: {
                    centerPadding: '2%',
                    appendArrows: '.m-gallery-carousel .js-arrow-navigation',
                    appendDots: '.m-gallery-carousel .js-dot-navigation',
                }
            }]
        });
    }
}); 